import React from 'react';

import { getTranslation } from 'helpers/getTranslation';

import { Loading } from 'components/shared/Loading';

import { EmptyState } from 'components/EmptyState';
import { TablePagination } from 'components/TablePagination';

import { Actions } from 'pages/InboxPage/components/Actions';
import { StudentsReviewsItem } from 'pages/InboxPage/components/StudentsReviewsItem';

import styles from './StudentsReviews.module.scss';

const StudentsReviews = ({
  locale,
  loading,
  studentsReviews,
  currentPage,
  totalPages,
  perPage,
  sortParams,
  onPerPageChange,
  onPrevPageClick,
  onNextPageClick,
  onSortChange,
}: {
  locale: any;
  loading: any;
  studentsReviews: any;
  currentPage: any;
  totalPages: any;
  perPage: any;
  sortParams: any;
  onPerPageChange: any;
  onPrevPageClick: any;
  onNextPageClick: any;
  onSortChange: any;
}) => (
  <>
    {loading ? (
      <Loading />
    ) : studentsReviews.length > 0 ? (
      <>
        <Actions onSortChange={onSortChange} sortParams={sortParams} />
        {studentsReviews.map((studentReview: any) => (
          <div className={styles.item} key={studentReview.id}>
            <StudentsReviewsItem
              studentReview={studentReview}
              locale={locale}
            />
          </div>
        ))}
        <TablePagination
          currentPage={currentPage}
          perPage={perPage}
          totalPages={totalPages}
          onPerPageChange={onPerPageChange}
          onNextPageClick={onNextPageClick}
          onPrevPageClick={onPrevPageClick}
        />
      </>
    ) : (
      <EmptyState
        className={styles.emptyState}
        icon="mail"
        title={getTranslation('inbox_page.students_reviews.empty_state.title')}
        text=""
      />
    )}
  </>
);
export default React.memo(StudentsReviews) as any;
